var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30.3999C23.9528 30.3999 30.3999 23.9528 30.3999 16C30.3999 8.04718 23.9528 1.6 16 1.6C8.04718 1.6 1.6 8.04718 1.6 16C1.6 23.9528 8.04718 30.3999 16 30.3999ZM16 31.9999C24.8368 31.9999 31.9999 24.8368 31.9999 16C31.9999 7.16319 24.8368 0 16 0C7.16319 0 0 7.16319 0 16C0 24.8368 7.16319 31.9999 16 31.9999Z",
    fill: "#004C6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.0003C26 27.7574 24.771 28.9161 24 28.9996C19.5 32.1942 17.2735 31.2044 11.5 30.621C11.2117 30.5914 7.73044 28.1791 7.50563 28.0003C7.28081 27.8214 6.58813 27.7702 6.5 27.5003C6.41187 27.2304 6 27.0003 6 27.0003C6 27.0003 7.28815 25.5115 7.50563 25.3242C14.3193 19.5201 18.2133 19.6 24.52 25.3183C24.8275 25.5968 26 26.5913 26 27.0003Z",
    fill: "#004C6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13C22 14.5913 21.3679 16.1174 20.2426 17.2426C19.1174 18.3679 17.5913 19 16 19C14.4087 19 12.8826 18.3679 11.7574 17.2426C10.6321 16.1174 10 14.5913 10 13C10 11.4087 10.6321 9.88258 11.7574 8.75736C12.8826 7.63214 14.4087 7 16 7C17.5913 7 19.1174 7.63214 20.2426 8.75736C21.3679 9.88258 22 11.4087 22 13Z",
    fill: "#004C6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/user-profile-icon.ff0838f8919c7031ec7afee9309dcbaa.svg";
export { ForwardRef as ReactComponent };